import { createContext } from "react";

const FiltersContext = createContext(null);

export default FiltersContext;
